import { render, staticRenderFns } from "./DeletePlantComponent.vue?vue&type=template&id=54a12828"
import script from "./DeletePlantComponent.vue?vue&type=script&lang=ts"
export * from "./DeletePlantComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports